import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/icon/metamask.svg';
import _imports_1 from '@/assets/icon/walletconnect.svg';

const _withScopeId = n => (_pushScopeId("data-v-668859e0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "wrapper"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "font-h5 title"
}, "Connect a wallet", -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "font-body3 desc"
}, " Choose your wallet with BNB Chain/Ethereum and sign to connect ", -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "metamask"
}, null, -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-subtitle1"
}, "MetaMask", -1));

const _hoisted_6 = [_hoisted_4, _hoisted_5];

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "walletconnect"
}, null, -1));

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-subtitle1"
}, "WalletConnect", -1));

const _hoisted_9 = [_hoisted_7, _hoisted_8];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_common_modal = _resolveComponent("common-modal");

  return _openBlock(), _createBlock(_component_common_modal, {
    name: "connect-wallet"
  }, {
    content: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _hoisted_3, $data.ethereum ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "row",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.metamask && $options.metamask(...args))
    }, _hoisted_6)) : _createCommentVNode("", true), _createElementVNode("div", {
      class: "row",
      onClick: _cache[1] || (_cache[1] = (...args) => $options.walletConnect && $options.walletConnect(...args))
    }, _hoisted_9)])]),
    _: 1
  });
}